import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FieldValue } from '../../../../../@core/models/site-material-data.model';


@Component({
    selector: 'app-material-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss']
})

export class MaterialDatepickerComponent {
    @Input() positionField: number = undefined;
    @Input() field: number = undefined;
    @Input() name: string;
    @Input() onBuilder: string = '';
    datepickerError: string = 'checked';
    @Output() setValueEvent = new EventEmitter<FieldValue>();

    constructor() {}

    getValue($event: {value: Date}) {
        if ( $event.value) {
            this.setValueEvent.emit({type: 'datepicker', value: this.dateFormat($event.value), required: false, position: this.field});
        }
    }
    dateFormat(date: Date) {
        const d = date;
        let month = String(d.getMonth() + 1);
        let day = String(d.getDate());
        const year = String(d.getFullYear());
        month = (month.length < 2) ? '0' + month : month;
        day = (day.length < 2) ? '0' + day : day;
        return `${month}/${day}/${year}`;
    }
}
